<template>
	<v-container 
			class="customVContainer"
			:style="$_resetPassword_stylePageContainerStyle()"
			fluid>
		<template v-if="initialized_">
			<v-row 
					class="customVRow" 
					align="center" 
					justify="center">
				<!-- input field -->
				<template v-if="mode_.reset">
					<v-col cols="10" sm="8" md="6">
						<validation-observer v-slot="validation">
							<v-form>
								<v-card color="transparent" flat>
									<template v-if="!isEmpty(errorMessage_)">
										<v-card-title>
											<span 	class="caption"
													v-html="errorMessage_" />
										</v-card-title>
									</template>
									<v-card-text>
										<validation-provider
												name="New Password"
												rules="required"
												mode="lazy"
												v-slot="{ errors }">
											<v-text-field
													v-model="form_.newPassword"

													:background-color="$_resetPassword_styleTextFieldBackgroundColor"
													:clearable="$_resetPassword_styleTextFieldClearable"
													:color="$_resetPassword_styleTextFieldColor"
													:counter="$_resetPassword_styleTextFieldCounter"
													:dark="$_resetPassword_styleTextFieldDark"
													:filled="$_resetPassword_styleTextFieldFilled"
													:flat="$_resetPassword_styleTextFieldFlat"
													:light="$_resetPassword_styleTextFieldLight"
													:outlined="$_resetPassword_styleTextFieldOutlined"
													:solo="$_resetPassword_styleTextFieldSolo"
													:solo-inverted="$_resetPassword_styleTextFieldSoloInverted"

													:append-outer-icon="$_resetPassword_styleTextFieldAppendOuterIcon"
													:prepend-icon="$_resetPassword_styleTextFieldPrependIcon"
													:prepend-inner-icon="$_resetPassword_styleTextFieldPrependInnerIcon"

													:hint="$_resetPassword_langNewPasswordHint"
													:mask="$_resetPassword_langNewPasswordMask"
													:message="$_resetPassword_langNewPasswordMessage"
													:placeholder="$_resetPassword_langNewPasswordPlaceholder"
													:prefix="$_resetPassword_langNewPasswordPrefix"
													:suffix="$_resetPassword_langNewPasswordSuffix"

													:append-icon="showPassword_ ? 'visibility_off' : 'visibility'"
													:type="showPassword_ ? 'text' : 'password'"

													:label="$_resetPassword_langNewPassword"

													:error-messages="errors"
													@click:append="showPassword_ = !showPassword_" />
										</validation-provider>
										<validation-provider
												name="Confirm Password"
												rules="required"
												v-slot="{ errors }">
											<v-text-field
													ref="confirmPassword"

													v-model="form_.confirmPassword"

													:background-color="$_resetPassword_styleTextFieldBackgroundColor"
													:clearable="$_resetPassword_styleTextFieldClearable"
													:color="$_resetPassword_styleTextFieldColor"
													:counter="$_resetPassword_styleTextFieldCounter"
													:dark="$_resetPassword_styleTextFieldDark"
													:filled="$_resetPassword_styleTextFieldFilled"
													:flat="$_resetPassword_styleTextFieldFlat"
													:light="$_resetPassword_styleTextFieldLight"
													:outlined="$_resetPassword_styleTextFieldOutlined"
													:solo="$_resetPassword_styleTextFieldSolo"
													:solo-inverted="$_resetPassword_styleTextFieldSoloInverted"

													:append-outer-icon="$_resetPassword_styleTextFieldAppendOuterIcon"
													:prepend-icon="$_resetPassword_styleTextFieldPrependIcon"
													:prepend-inner-icon="$_resetPassword_styleTextFieldPrependInnerIcon"

													:hint="$_resetPassword_langConfirmPasswordHint"
													:mask="$_resetPassword_langConfirmPasswordMask"
													:message="$_resetPassword_langConfirmPasswordMessage"
													:placeholder="$_resetPassword_langConfirmPasswordPlaceholder"
													:prefix="$_resetPassword_langConfirmPasswordPrefix"
													:suffix="$_resetPassword_langConfirmPasswordSuffix"

													:append-icon="showPassword_ ? 'visibility_off' : 'visibility'"
													:type="showPassword_ ? 'text' : 'password'"

													:label="$_resetPassword_langConfirmPassword"

													:error-messages="errors"
													@click:append="showPassword_ = !showPassword_" />
										</validation-provider>
									</v-card-text>
									<v-card-actions class="center">
										<v-btn	class="customVBtn"

												:disable="!validation.passed && !validation.valid"

												:block="$_resetPassword_styleResetButtonBlock"
												:color="$_resetPassword_styleResetButtonColor"
												:dark="$_resetPassword_styleResetButtonDark"
												:depressed="$_resetPassword_styleResetButtonDepressed"
												:elevation="$_resetPassword_styleResetButtonElevation"
												:large="$_resetPassword_styleResetButtonLarge"
												:light="$_resetPassword_styleResetButtonLight"
												:outlined="$_resetPassword_styleResetButtonOutlined"
												:rounded="$_resetPassword_styleResetButtonRounded"
												:small="$_resetPassword_styleResetButtonSmall"
												:text="$_resetPassword_styleResetButtonFlat"
												@click="$_resetPassword_reset()"
												v-text="$_resetPassword_langResetButton" />
										<v-btn	class="customVBtn"
												:block="$_resetPassword_styleCancelButtonBlock"
												:color="$_resetPassword_styleCancelButtonColor"
												:dark="$_resetPassword_styleCancelButtonDark"
												:depressed="$_resetPassword_styleCancelButtonDepressed"
												:elevation="$_resetPassword_styleCancelButtonElevation"
												:large="$_resetPassword_styleCancelButtonLarge"
												:light="$_resetPassword_styleCancelButtonLight"
												:outlined="$_resetPassword_styleCancelButtonOutlined"
												:rounded="$_resetPassword_styleCancelButtonRounded"
												:small="$_resetPassword_styleCancelButtonSmall"
												:text="$_resetPassword_styleCancelButtonFlat"
												to="/"
												v-text="$_resetPassword_langCancelButton" />
									</v-card-actions>
								</v-card>
							</v-form>
						</validation-observer>
					</v-col>
				</template>
				<!--  completed -->
				<template v-if="mode_.completed">
					<v-col>
						<v-card color="transparent" flat>
							<v-card-text class="center">
								<span v-html="$_resetPassword_langCompletedText" />
							</v-card-text>
							<v-card-actions class="center">
								<v-btn	class="customVBtn"
										:block="$_resetPassword_styleOkButtonBlock"
										:color="$_resetPassword_styleOkButtonColor"
										:dark="$_resetPassword_styleOkButtonDark"
										:depressed="$_resetPassword_styleOkButtonDepressed"
										:elevation="$_resetPassword_styleOkButtonElevation"
										:large="$_resetPassword_styleOkButtonLarge"
										:light="$_resetPassword_styleOkButtonLight"
										:outlined="$_resetPassword_styleOkButtonOutlined"
										:rounded="$_resetPassword_styleOkButtonRounded"
										:small="$_resetPassword_styleOkButtonSmall"
										:text="$_resetPassword_styleOkButtonFlat"
										@click="openLink($_resetPassword_linkOkButton)"
										v-text="$_resetPassword_langOkButton" />
							</v-card-actions>
						</v-card>
					</v-col>
				</template>
			</v-row>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</v-container>
</template>

<script>
	export default {
		name: 'ResetPassword',
		data() {
			return {
				pageName_: 'resetPassword',
				pageType_: 'resetPassword',

				initialized_: false,

				showPassword_: false,
				errorMessage_: '',

				mode_: {
					reset: true,
					completed: false
				},

				form_: {
					newPassword: null,
					confirmPassword: null
				}
			}
		},
		computed: {
			// current user
			$_resetPassword_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			$_resetPassword_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_resetPassword_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			// contents / inits
			$_resetPassword_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_resetPassword_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_resetPassword_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_resetPassword_inits(), 'contact')
			},
			// lang
			$_resetPassword_langNewPassword() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'newPassword')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langNewPasswordHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'newPasswordHint')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langNewPasswordMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'newPasswordMask')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langNewPasswordMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'newPasswordMessage')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langNewPasswordPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'newPasswordPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langNewPasswordPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'newPasswordPrefix')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langNewPasswordSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'newPasswordSuffix')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langNewPasswordType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'newPasswordType')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langConfirmPassword() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'confirmPassword')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langConfirmPasswordHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'confirmPasswordHint')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langConfirmPasswordMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'confirmPasswordMask')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langConfirmPasswordMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'confirmPasswordMessage')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langConfirmPasswordPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'confirmPasswordPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langConfirmPasswordPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'confirmPasswordPrefix')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langConfirmPasswordSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'confirmPasswordSuffix')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langConfirmPasswordType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'confirmPasswordType')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langResetButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'resetButton')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langCancelButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'cancelButton')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'okButton')
				return self_.getLangsVal(lang_)
			},
			$_resetPassword_langCompletedText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_resetPassword_inits(), 'completedText')
				return self_.getLangsVal(lang_)
			},
			// link
			$_resetPassword_linkOkButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.$_resetPassword_inits(), 'okButton')
			},
			// style
			$_resetPassword_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_resetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_resetPassword_inits(), 'pageContainer')
			},
			$_resetPassword_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const pageContainer_ = self_.$_resetPassword_stylePageContainer;
					if(self_.isFalse(pageContainer_)) { return null }
					return self_.getStylesVal(pageContainer_.style)
				}
			},
			$_resetPassword_styleTextField() {
				const self_ = this;
				if(self_.isEmpty(self_.$_resetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_resetPassword_inits(), 'textField')
			},
			$_resetPassword_styleTextFieldAppendOuterIcon() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.appendOuterIcon)
			},
			$_resetPassword_styleTextFieldBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_resetPassword_styleTextFieldClearable() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_resetPassword_styleTextFieldColor() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_resetPassword_styleTextFieldCounter() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_resetPassword_styleTextFieldDark() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_resetPassword_styleTextFieldFilled() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_resetPassword_styleTextFieldFlat() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_resetPassword_styleTextFieldLight() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_resetPassword_styleTextFieldOutlined() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_resetPassword_styleTextFieldPrependIcon() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.prependIcon)
			},
			$_resetPassword_styleTextFieldPrependInnerIcon() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.prependInnerIcon)
			},
			$_resetPassword_styleTextFieldSolo() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_resetPassword_styleTextFieldSoloInverted() {
				const self_ = this;
				const style_ = self_.$_resetPassword_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_resetPassword_styleResetButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_resetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_resetPassword_inits(), 'resetButton')
			},
			$_resetPassword_styleResetButtonBlock() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_resetPassword_styleResetButtonColor() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_resetPassword_styleResetButtonDark() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_resetPassword_styleResetButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_resetPassword_styleResetButtonElevation() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_resetPassword_styleResetButtonFlat() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_resetPassword_styleResetButtonLarge() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_resetPassword_styleResetButtonLight() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_resetPassword_styleResetButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_resetPassword_styleResetButtonRounded() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_resetPassword_styleResetButtonSmall() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_resetPassword_styleCancelButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_resetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_resetPassword_inits(), 'cancelButton')
			},
			$_resetPassword_styleCancelButtonBlock() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_resetPassword_styleCancelButtonColor() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_resetPassword_styleCancelButtonDark() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_resetPassword_styleCancelButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_resetPassword_styleCancelButtonElevation() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_resetPassword_styleCancelButtonFlat() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_resetPassword_styleCancelButtonLarge() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_resetPassword_styleCancelButtonLight() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_resetPassword_styleCancelButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_resetPassword_styleCancelButtonRounded() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_resetPassword_styleCancelButtonSmall() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_resetPassword_styleOkButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_resetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_resetPassword_inits(), 'okButton')
			},
			$_resetPassword_styleOkButtonBlock() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_resetPassword_styleOkButtonColor() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_resetPassword_styleOkButtonDark() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_resetPassword_styleOkButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_resetPassword_styleOkButtonElevation() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_resetPassword_styleOkButtonFlat() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_resetPassword_styleOkButtonLarge() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_resetPassword_styleOkButtonLight() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_resetPassword_styleOkButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_resetPassword_styleOkButtonRounded() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_resetPassword_styleOkButtonSmall() {
				const self_ = this;
				const button_ = self_.$_resetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_resetPassword_setPageState()

			if(self_.$_resetPassword_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_resetPassword_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_resetPassword_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_resetPassword_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_resetPassword_initialize()', error)
				})
			},
			$_resetPassword_reset() {
				const self_ = this;

				if(self_.form_.newPassword != self_.form_.confirmPassword) {
					self_.errorMessage_ = 'Password does not match.';
					return
				}

				const uid_ = self_.$_resetPassword_currentUserUid;
				const password_ = self_.form_.newPassword;

				Promise.resolve().then(() => {
					return self_.resetPassword(uid_, password_)
				}).then(() => {
					return self_.ipcEditPassword(uid_)
				}).then(() => {
					return self_.ipCliUpdateAppUserOptions(uid_, { resetPassword: false })
				}).then(() => {
					self_.mode_ = {
						reset: false,
						completed: true
					}
				}).catch(error => {
/* error */			self_.logError('Error', '$_resetPassword_reset()', error)
						
					// (for error below)
					// This operation is sensitive and requires recent authentication.
					// Log in again before retrying this request
					self_.logout()
				})
			}
		}
	}
</script>

<style scoped>
</style>